<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">小程序商城</el-breadcrumb-item>
        <el-breadcrumb-item>小程序会员管理</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-form :model="querys" ref="querys" label-width="90px" class="search-form" size="default">
      <el-row>
        <el-form-item label="关键词" prop="keyword">
          <el-col>
            <el-input v-model="querys.keyword" prefix-icon="Search" @keyup.enter="fetchs" placeholder="请输入用户昵称、真实姓名、手机号或邮箱"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-col>
            <el-input v-model="querys.phone" placeholder="请输入手机号" clearable style="width: 120px;"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="用户状态" prop="status">
          <el-col>
            <el-select v-model="querys.status" placeholder="请选择用户状态" clearable style="width: 80px;" @change="onStatusChange">
              <el-option label="全部" value="all"></el-option>
              <el-option label="正常" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-col>
            <el-select v-model="querys.gender" placeholder="请选择性别" clearable style="width: 80px;" @change="onGenderChange">
              <el-option label="全部" value="all"></el-option>
              <el-option label="男" value="男"></el-option>
              <el-option label="女" value="女"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="" label-width="20px">
          <el-button type="primary" icon="Search" @click="fetchs()">
            搜索
          </el-button>
          <el-button icon="Refresh" @click="resetSearch()" style="margin-left: 10px;">
            重置
          </el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <div class="toolbar">
      <el-button type="primary" icon="View" @click="goToOrders" :disabled="!currRow || !currRow.id">
        查看该用户订单
      </el-button>
      <el-button type="danger" icon="Delete" @click="handleDelete">
        删除
      </el-button>
    </div>

    <basic-table class="table"  :query="querys" @handler="fetchs" :currHandler="currHandler">
      <template v-slot:productImg="scope">
        <el-image style="height: 32px; width: 32px" lazy :src="apiUrl + 'static/code/' + scope.row.productCode + '?t=0'"
          :preview-src-list="[apiUrl + 'static/code/' + scope.row.productCode + '?t=1']">
          <template #error>
            <img style="width: 100%" src="~@/assets/imgunfine.jpg" alt="" />
          </template>
        </el-image>
      </template>
      <template v-slot:orderStatus="scope">
        <el-tag :type="getOrderStatusType(scope.row.orderStatus)">
          {{ getOrderStatusText(scope.row.orderStatus) }}
        </el-tag>
      </template>
      <template v-slot:payStatus="scope">
        <el-tag :type="scope.row.payStatus === 1 ? 'success' : 'warning'">
          {{ scope.row.payStatus === 1 ? '已支付' : '未支付' }}
        </el-tag>
      </template>
      <template v-slot:toolbar="scope">
        <el-button @click="view(scope.row)" type="primary" link size="small">
          [查看]
        </el-button>
      </template>
    </basic-table>

    <static-dialog ref="dialog" class="dialog" title="商品信息维护" :opened="opened" :ok="submit">
      <el-form :model="forms" :rules="rules" ref="forms" :label-width="labelWidth">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item label="商品类别" prop="metalCode">
              <el-select v-model="forms.metalCode" placeholder="请选择" @change="chooseOption($event, dict.metals)"
                :disabled="forms.id">
                <el-option v-for="item in dict.metals" :key="item.id" :label="item.value" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16">
            <el-form-item label="商品名称" prop="productName" style="max-width: 95%">
              <el-input v-model="forms.productName" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item label="图片上传" prop="productTags">
              <el-upload :action="apiUrl + '/ShopProduct/Uploader?dataType=main&productCode=' + forms.productCode"
                list-type="picture-card" :on-success="uploadHandleSuccess" :on-remove="uploadHandleRemove"
                :before-upload="uploadHandleBefore" :file-list="fileList">
                <el-icon>
                  <Plus />
                </el-icon>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </static-dialog>

    <!-- 用户详情查看弹窗 -->
    <el-dialog v-model="userDetailVisible" title="用户详情" width="60%" :close-on-click-modal="false">
      <el-form :model="userDetail" label-width="120px" v-if="userDetail">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户昵称">
              <el-input v-model="userDetail.userName" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="真实姓名">
              <el-input v-model="userDetail.realName" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别">
              <el-input v-model="userDetail.gender" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号">
              <el-input v-model="userDetail.phone" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱">
              <el-input v-model="userDetail.email" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="省份">
              <el-input v-model="userDetail.province" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="城市">
              <el-input v-model="userDetail.city" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="微信头像">
              <el-input v-model="userDetail.avatarUrl" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-input v-model="userDetail.status" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最后登录时间">
              <el-input v-model="userDetail.lastLoginTime" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册时间">
              <el-input v-model="userDetail.registerTime" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="过期时间">
              <el-input v-model="userDetail.expiredDate" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="App ID">
              <el-input v-model="userDetail.appId" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Open ID">
              <el-input v-model="userDetail.openId" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Union ID">
              <el-input v-model="userDetail.unionId" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间">
              <el-input v-model="userDetail.createDate" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建人">
              <el-input v-model="userDetail.createUserName" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="更新时间">
              <el-input v-model="userDetail.updateDate" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="更新人">
              <el-input v-model="userDetail.updateUserName" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="userDetailVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </el-card>
</template>
<script>
import { fetchFileList } from "@/api/basic";
import { fetchShopuser, exportShopuser, fixShopuser, delShopuser } from "@/api/shop";
import StaticDialog from "@/components/static-dialog.vue";
import BasicTable from "@/components/basic-table.vue";
export default {
  name: "shopUser",
  components: { StaticDialog, BasicTable },
  data() {
    return {
      apiUrl: '',
      productCode: "",
      querys: {
        keyword: "",
        status: "all",
        gender: "all",
        phone: "",
        filters: [],
        columns: [
          { type: "index", label: "序号" },
          { prop: "id", label: "用户ID", sortable: true, searchable: true, width: "200", showOverflowTooltip: true },
          { prop: "userName", label: "用户昵称", sortable: true, searchable: true, width: "120", showOverflowTooltip: true },
          { prop: "realName", label: "真实姓名", sortable: true, searchable: true, width: "120", showOverflowTooltip: true },
          { prop: "gender", label: "性别", sortable: true, width: "80", showOverflowTooltip: true },
          { prop: "phone", label: "手机号", sortable: true, searchable: true, width: "120", showOverflowTooltip: true },
          { prop: "email", label: "邮箱", sortable: true, searchable: true, width: "180", showOverflowTooltip: true },
          { prop: "province", label: "省份", sortable: true, width: "100", showOverflowTooltip: true },
          { prop: "city", label: "城市", sortable: true, width: "100", showOverflowTooltip: true },
          { prop: "avatarUrl", label: "微信头像", width: "80", showOverflowTooltip: true },
          { prop: "status", label: "状态", sortable: true, width: "80", showOverflowTooltip: true },
          { prop: "lastLoginTime", label: "最后登录", sortable: true, width: "160", showOverflowTooltip: true },
          { prop: "registerTime", label: "注册时间", sortable: true, width: "160", showOverflowTooltip: true },
          { prop: "createDate", label: "创建时间", sortable: true, width: "160", showOverflowTooltip: true },
          { prop: "createUserName", label: "创建人", sortable: true, width: "100", showOverflowTooltip: true },
          { prop: "updateDate", label: "更新时间", sortable: true, width: "160", showOverflowTooltip: true },
          { prop: "updateUserName", label: "更新人", sortable: true, width: "100", showOverflowTooltip: true },
          { type: "toolbar", label: "操作", width: "90" }
        ],
        sidx: "id",
        sord: "descending",
      },
      currRow: null,
      centerDialogVisible: false,
      dialogWidth: "30%",

      dict: {
        categorys: [],
        brands: [],
        factorys: [],
      },
      forms: {},
      labelWidth: "110px",
      rules: {
      },
      fileList: [],
      userDetailVisible: false,
      userDetail: null
    };
  },
  mounted() {
    this.fetchs();
    this.apiUrl = process.env.VUE_APP_BASEURL;
  },
  methods: {
    add() {
      this.currRow = {};
      this.$refs.dialog.toggle();
    },
    edit(row) {
      this.currRow = row;
      this.$refs.dialog.toggle();
    },
    view(row) {
      this.currRow = row;
      this.userDetailVisible = true;
      this.userDetail = null;
      
      // 调用API获取用户详情
      this.fetchUserDetail(row.id);
    },
    fetchUserDetail(userId) {
      // 使用fetch API调用接口
      fetch(`${this.apiUrl}ShopUser/${userId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${sessionStorage.getItem('access_token') || ''}`,
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(res => {
        if (res.code === 200) {
          this.userDetail = res.data;
        } else {
          this.$message({
            type: 'error',
            message: res.content || '获取用户详情失败'
          });
        }
      })
      .catch(error => {
        console.error('获取用户详情失败:', error);
        this.$message({
          type: 'error',
          message: '获取用户详情失败'
        });
      });
    },
    goToOrders() {
      if (this.currRow && this.currRow.id) {
        // 跳转到订单页面并传递用户ID参数
        this.$router.push({
          path: '/shop/order',
          query: {
            userId: this.currRow.id
          }
        });
      } else {
        this.$message({
          type: 'warning',
          message: '请先选择用户'
        });
      }
    },
    handleDelete() {
      if (!this.currRow) {
        this.$message({
          type: 'warning',
          message: '请先选择要删除的用户'
        });
        return;
      }
      this.del(this.currRow);
    },
    del(row) {
      this.currRow = row;
      let that = this;

      this.$confirm("此操作将删除本行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delShopuser(that.currRow.id).then((res) => {
          that.$message({
            type: res.type,
            message: res.content,
          });
          that.fetchs();
        });
      });
    },
    chooseOption(value, options) {
      let items = options.filter(function (item) {
        return item.value == value;
      });
      if (items && items.length > 0) {
        let that = this;
        fetchShopCode(items[0].attribute || "Z").then((res) => {
          that.forms.productCode = res.data;

          getPrevID().then((res) => {
            that.forms.id = res;
          });
        });
      }
    },
    opened() {
      let that = this;

    },
    submit() {
      let that = this;

      this.$refs.forms.validate((valid) => {
        if (!valid) return;

        that.forms.brandCode = chooseBrands[0].name;
        // that.forms.factoryCode = chooseFactorys[0].name;
        submitShopinfo((that.currRow.id || ''), that.forms).then((res) => {
          that.$message({
            type: res.type,
            message: res.content,
          });

          if (res.data) {
            that.fetchs();
            that.$refs.dialog.toggle();
          }
        });
      });
    },
    fetchs() {
      this.querys.filters = [];
      
      // 用户状态筛选
      if (this.querys.status !== "" && this.querys.status !== "all") {
        this.querys.filters.push({
          name: "status",
          value: this.querys.status,
          operate: 0,
        });
      }
      
      // 性别筛选
      if (this.querys.gender !== "" && this.querys.gender !== "all") {
        this.querys.filters.push({
          name: "gender",
          value: this.querys.gender,
          operate: 0,
        });
      }
      
      // 手机号筛选
      if (this.querys.phone && this.querys.phone.trim() !== "") {
        this.querys.filters.push({
          name: "phone",
          value: "%" + this.querys.phone.trim() + "%",
          operate: 5,
        });
      }
      
      let { data, records, total, ...search } = {
        ...this.querys,
      };

      fetchShopuser(search).then((res) => {
        this.querys = { ...res.data };
      });
    },
    currHandler(row) {
      this.currRow = row;
    },
    pageHandler(page) {
      this.querys.page = page;
      this.fetchs();
    },
    sizeHandler(rows) {
      this.querys.rows = rows;
      this.fetchs();
    },
    sortHandler(order) {
      this.querys.sidx = order.prop;
      this.querys.sord = order.order;
      this.fetchs();
    },
    //控制dialog宽度与子组件控制关闭弹窗
    getdialogWidth(data) {
      if (data === "80%" || data === "30%") {
        this.dialogWidth = data;
      } else {
        this.centerDialogVisible = false;
      }
    },

    uploadHandleBefore(file) {
      console.log(file)
      if (!this.forms.id || !this.forms.productCode)
        return false;
    },
    uploadHandleRemove(file, fileList) {
      console.log(file.id, fileList)
      delShopFile(file.id).then((res) => {
        this.$message({
          type: res.type,
          message: res.content,
        });
      });
    },
    uploadHandleSuccess(res, file, fileList) {
      console.log(res, file, fileList)
      this.$message({
        type: res.type,
        message: res.content,
      });

      if (res.code != 200) {
        fileList = fileList.pop()
      }
    },
    getOrderStatusType(status) {
      const statusTypeMap = {
        '-1': 'danger',
        '0': 'info',
        '1': 'warning',
        '2': 'primary',
        '3': 'success'
      };
      return statusTypeMap[status] || 'info';
    },
    getOrderStatusText(status) {
      const statusMap = {
        '-1': '已取消',
        '0': '未支付',
        '1': '已支付',
        '2': '已发货',
        '3': '已完成'
      };
      return statusMap[status] || '未知状态';
    },
    resetSearch() {
      this.querys.keyword = "";
      this.querys.status = "all";
      this.querys.gender = "all";
      this.querys.phone = "";
      this.$nextTick(() => {
        this.$forceUpdate();
      });
      this.fetchs();
    },
    onStatusChange(value) {
      this.querys.status = value;
    },
    onGenderChange(value) {
      this.querys.gender = value;
    },
  },
};
</script>
<style lang="less">
.xlsdialog {
  .el-dialog__body {
    max-height: 80vh;
    overflow-y: auto;
  }
}

.el-form .el-date-editor {
  width: 220px;
}
</style>>




